<template>
  <div style="width: 100%">
    <div class="flex flex-column lg:flex-row" style="display: flex; justify-content: center">
      <template>
        <DashboardCard
          v-for="(card, index) in cardsData"
          :cardName="card.cardName"
          :pendings="getStatistics(card.statisticsName).pendientes"
          :expireds="getStatistics(card.statisticsName).vencidos"
          :color="card.color"
          :key="index"
        />
      </template>
    </div>
  </div>
</template>

<script setup>
import { onMounted, watch, computed } from "vue";
import DashboardCard from "@/components/Dashboard/DashboardCard";
import { useStoreCompat } from "@/composables/useStoreCompat";
import { useDashboardStatistics } from "@/composables/useDashboardStatistics";
import { useProsecutorData } from "@/composables/useProsecutorData";

const props = defineProps({
  dependencia: {
    type: String,
    default: null,
  },
});

const store = useStoreCompat();
const { prosecutorUserTypes } = useProsecutorData();
const {
  policeCardsData,
  UFIsCardsData,
  UFIsCardsDataStatisticsName,
  showProgressSpinner,
  getData,
  getStatistics,
} = useDashboardStatistics();

const dependenciaID = computed(() => store.state.user.userdata.dependenciaID);
const usuario = computed(() => store.state.user);
const CategoriaUfiID = computed(() => store.state.user.userdata.CategoriaUfiID);

const cardsData = computed(() => {
  let cards = [];
  if (prosecutorUserTypes.value && Array.isArray(prosecutorUserTypes.value)) {
    if (prosecutorUserTypes.value.includes(store.state.user.userdata.tipoUsuario)) {
      const currentUFI = {
        ...UFIsCardsData[store.state.user.userdata.CategoriaUfiID],
      };
      currentUFI.statisticsName = UFIsCardsDataStatisticsName;
      cards = [currentUFI];
    } else {
      cards = policeCardsData;
    }
  }
  return cards;
});

onMounted(async () => {
  await store.dispatch("siis/setDependencias");
  const user = store.state.user;
  const userID = user.userdata.userId;
  const basicUrl = process.env.VUE_APP_BACKEND_ENVIRONMENT;
  const search = [
    {
      "exp_pre_EstadoActuacion.TipoEstadoActuacionID": [{ operator: "=", value: "En Curso" }],
    },
    {
      "exp_pre_EstadoActuacion.TipoEstadoActuacionID": [{ operator: "=", value: "Vencida" }],
    },
  ];
  if (store.state.user.userdata.tipoUsuario === "Oficial Sumariante") {
    search[0]["exp_pre_ActuacionUsuarioDependencia.ActuacionUsuarioDependenciaID"] = [
      { operator: "=", value: userID },
    ];
    search[1]["exp_pre_ActuacionUsuarioDependencia.ActuacionUsuarioDependenciaID"] = [
      { operator: "=", value: userID },
    ];
  }
  const paramsPendientes = `search=${JSON.stringify(search[0])}`;
  const paramsVencidos = `search=${JSON.stringify(search[1])}`;

  await getData([
    `${basicUrl}/Actuacion/estadisticas?${paramsPendientes}`,
    `${basicUrl}/Actuacion/estadisticas?${paramsVencidos}`,
  ]);
});

watch(
  () => props.dependencia,
  (actual = "") => {
    showProgressSpinner.value = true;
    const value = actual;
    const paramsPendientes = `search={"exp_pre_EstadoActuacion.TipoEstadoActuacionID":[{"operator":"=","value":"En Curso"}]${
      value
        ? `,"exp_pre_ActuacionUsuarioDependencia.DependenciaID":[{"operator":"=","value":"${value}"}]`
        : ""
    }}`;
    const paramsVencidos = `search={"exp_pre_EstadoActuacion.TipoEstadoActuacionID":[{"operator":"=","value":"Vencida"}]${
      value
        ? `,"exp_pre_ActuacionUsuarioDependencia.DependenciaID":[{"operator":"=","value":"${value}"}]`
        : ""
    }}`;
    const basicUrl = process.env.VUE_APP_BACKEND_ENVIRONMENT;
    getData([
      `${basicUrl}/Actuacion/estadisticas?${paramsPendientes}`,
      `${basicUrl}/Actuacion/estadisticas?${paramsVencidos}`,
    ]);
  }
);
</script>

<style></style>
